<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("car_rents_order") }}</v-toolbar-title>
    </v-toolbar>

    <!-- table -->
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      pathName="car-rent-orders"
      resName="car_rent_orders"
      class="table-row"
    >
      <template slot-scope="{ item }">
        <td class="text-sm-center">
          {{ `${item.reference_number}` }}
        </td>
        <td class="text-sm-center">
          {{ `${item.car_rent_name}` }}
        </td>

        <td class="text-sm-center">
          {{ item.grand_total }}
        </td>
        <td class="text-sm-center">
          <v-chip :color="orderStatus(item).color">
            <span style="color: #fff"> {{ orderStatus(item).name }}</span>
          </v-chip>
        </td>

        <td class="text-sm-center">
          <v-btn icon @click="handleShowOrderDetails(item)">
            <v-icon small :title="$t('icon.show')">mdi-eye</v-icon>
          </v-btn>
        </td>
      </template>
    </wrapping-table>
    <OrderDetails
      :dialog.sync="dialog"
      :item="item"
      @refresh-table="$refs.table_ref.handleGetItems()"
    />
  </div>
</template>

<script>
export default {
  name: "TripOrders",
  components: {
    OrderDetails: () => import("./orderDetails.vue")
  },

  data() {
    return {
      headers: ["reference_number", "name", "total_price", "status", "actions"],

      dialog: false,
      item: {}
    };
  },
  methods: {
    orderStatus(item) {
      const activeStatus = item.statuses.filter(status => status.active);
      return activeStatus[activeStatus.length - 1];
    },
    handleShowOrderDetails(item) {
      this.dialog = true;
      this.item = item;
    },
    ClearAllFilters() {
      this.$refs.toggle_filter_ref.ClearFilter();
    }
  }
};
</script>
